import CupIcon from '@icons/CupIcon';
import HeartEmptyIcon from '@icons/HeartEmptyIcon';
import RocketIcon from '@icons/RocketIcon';
import SparklesFilledIcon from '@icons/SparklesFilledIcon';
import StarIcon from '@icons/StarIcon';
import SuccessCircleIcon from '@icons/SuccessCircleIcon';
import TrendingUpIcon from '@icons/TrendingUpIcon';
import UserRoundIcon from '@icons/UserRoundIcon';
import { GoalLandingPageSocialProofFeatureIcon } from '@models/goals';

type IconRenderer = (size: number, color?: string) => React.ReactNode;

const ICON_RENDERERS: Record<GoalLandingPageSocialProofFeatureIcon, IconRenderer> = {
  [GoalLandingPageSocialProofFeatureIcon.CHECK]: (size) => <SuccessCircleIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.STAR]: (size) => <StarIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.HEART]: (size) => <HeartEmptyIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.PERSON]: (size) => <UserRoundIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.CUP]: (size, color) => (
    <CupIcon size={size} fillColor={color} />
  ),
  [GoalLandingPageSocialProofFeatureIcon.ROCKET]: (size) => <RocketIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.SPARKLES]: (size) => <SparklesFilledIcon size={size} />,
  [GoalLandingPageSocialProofFeatureIcon.TRENDING]: (size) => <TrendingUpIcon size={size} />
};

export const SOCIAL_PROOF_FEATURE_ICON_KEYS = Object.keys(
  ICON_RENDERERS
) as GoalLandingPageSocialProofFeatureIcon[];

export const DEFAULT_SOCIAL_PROOF_FEATURE_ICON = GoalLandingPageSocialProofFeatureIcon.CHECK;

export default function SocialProofFeatureIcon({
  icon,
  color,
  size = 24
}: {
  icon?: GoalLandingPageSocialProofFeatureIcon;
  color?: string;
  size?: number;
}) {
  const key = icon ?? DEFAULT_SOCIAL_PROOF_FEATURE_ICON;
  return (
    <span
      className='inline-flex shrink-0'
      style={{ color }}
      data-testid={`social-proof-icon-${key}`}
    >
      {ICON_RENDERERS[key](size, color)}
    </span>
  );
}
